import cn from "classnames";
import { dateTimeToView, humanizedSecondsRange } from "helpers/date";
import React, { useEffect, useState } from "react";
import { getLastNeuralNetworkTask } from "sources/admin";

const LastNeuralNetworkTask = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        getLastNeuralNetworkTask().then((data) => {
            setData(data);
            setLoading(false);
        });
    }, []);

    return (
        <div className={cn({ loading })}>
            <table className="table table-sm">
                <tbody>
                    <tr>
                        <th>Дата запуска обучения</th>
                        <td>{dateTimeToView(data.startedAt)}</td>
                    </tr>
                    <tr>
                        <th>Дата окончания обучения</th>
                        <td>{dateTimeToView(data.endedAt)}</td>
                    </tr>
                    <tr>
                        <th>Дата начала поиска заявок</th>
                        <td>{dateTimeToView(data.bidsStartDate)}</td>
                    </tr>
                    <tr>
                        <th>Дата начала поиска оcтановок</th>
                        <td>{dateTimeToView(data.stopsStartDate)}</td>
                    </tr>
                    <tr>
                        <th>Данные для отчета</th>
                        <td>
                            {data.reportData && (
                                <>
                                    <div>
                                        Всего заявок: <b>{data.reportData.totalBidsCount}</b>
                                    </div>
                                    <div>
                                        Заявок обработано: <b>{data.reportData.processedBidsCount}</b>
                                    </div>
                                    <div>
                                        Дата последней обработанной завяки:{" "}
                                        <b>{dateTimeToView(data.reportData.lastBidEndedAt)}</b>
                                    </div>
                                    <div>
                                        Кол-во точек загрузки/выгрузки для анализа:{" "}
                                        <b>{data.reportData.unloadPointsCount}</b>
                                    </div>
                                    <div>
                                        Кол-во остановок по заявкам: <b>{data.reportData.stopsCount}</b>
                                    </div>
                                    <div>
                                        Сбор данных:{" "}
                                        <b>{humanizedSecondsRange(data.reportData.dataCollectedInSeconds)}</b>
                                    </div>
                                    <div>
                                        Время обучения модели данных (при наличии):&nbsp;
                                        <b>{humanizedSecondsRange(data.reportData.modelTrainedInSeconds)}</b>
                                    </div>
                                </>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default LastNeuralNetworkTask;
